export default __webpack_public_path__ + "static/street-957708f55a804e754cf4f120832fa94c.jpg";